<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      theme: 'moonLightWhite'
    }
  },
  created(){
    this.$store.watch((state, getters) => {
      if(state.user.theme){
        this.theme = state.user.theme
      }
    })
    
  }
}
</script>